<div [class.has-searched]="hasSearched" [class.from-table-view]="fromTableView" >
  @if (showDetailed && specifications) {
    <input type="search" class="form-control mt-2" [placeholder]="'KEYWORD'|translate" (keyup)="hasSearched = true" [(ngModel)]="keyword" />
  }
  @if (!showDetailed && specifications) {
    <h4 class="mb-3">{{"SPECIFICATIONS"|translate}}</h4>
  }

  @if (specifications) {
    <div
      class="card-columns gap-2 specs-container"
    [style.column-count]="
      fromTableView ? 1 : kioskMode ? 2 : (showDetailed && specifications.length > 1 ? 3 : 1)
    "
      [ngClass]="[!showDetailed && specifications.length > 2 ? 'compact' : '','groups-' + specifications.length]"
      >
      @for (specGroup of specifications; track specGroup) {
        <div
          class="border-0 card bg-transparent card-pin"
          [ngClass]="!showDetailed ? 'pt-3 pb-1' : ''"
          >
          <div
            class="card-body px-0"
        [ngClass]="[
          specGroup.expanded ? 'expanded' : '',
          !showDetailed && !specGroup.expanded ? 'p-0' : ''
        ]"
            >
            <h5
              class="card-title"
              (click)="specGroup.expanded = specGroup.expanded ? false : true"
              >
              {{
              specGroup.description ? specGroup.description : ("OTHER" | translate)
              }}
            </h5>
            @if (specGroup && specGroup.items) {
              <ul
                class="ps-0 list-group list-group-flush"
                [ngClass]="'groups-' + specifications.length"
                >
                @if (!kioskMode) {
                  @for (spec of specGroup.items; track spec) {
                    <li
                      class="ps-0 py-0 list-group-item bg-transparent"
                      >
                      @if (
                        spec.code == 'DELIVERY_CONTENTS' && spec.value?.length >= 35) {
                        <span class="spec-label" [innerHTML]="spec.description + ':'"></span>
                        <ul>
                          @for (
                            item of splitStringIntoArrayByCommaOrStar(spec.value)
                            ; track
                            item) {
                            @if (!keyword || matchesKeyword(item)) {
                              <li [innerHTML]="item"></li>
                            }
                          }
                        </ul>
                      } @else {
                        @if (!keyword || matchesKeyword(spec.description + ': ' + spec.value)) {
                          <span
                            class="d-flex py-2"
                            [class.flex-column]="!fromTableView"
                            [class.flex-row]="fromTableView"
                            [class.align-items-start]="fromTableView"
                            [@inOutAnimation]
                            ><span class="spec-label" [class.w-50]="fromTableView" [innerHTML]="spec.description + ':&nbsp;'"></span><span class="spec-value" [class.w-50]="fromTableView" [innerHTML]="spec.value"></span>
                          </span>
                        }
                      }
                    </li>
                  }
                }
                @if (kioskMode) {
                  @for (spec of specGroup.items; track spec) {
                    <li class="ps-0 list-group-item">
                      <span
                        class="spec-description"
                        [innerHTML]="spec.description + ':'"
                      ></span>
                      <span class="spec-value" [innerHTML]="spec.value"></span>
                    </li>
                  }
                }
              </ul>
            }
          </div>
        </div>
      }
      @if (!keyword.length && (height > 500 || specsCollapsed) && hasBeenCollapsed) {
        <span class="toggle clickable" (click)="specsCollapsed = !specsCollapsed"><i class="material-icons">{{specsCollapsed ? 'keyboard_arrow_down' : 'keyboard_arrow_up'}}</i></span>
      }
    </div>
  }
  <app-disclaimer
    [companyGroups]="['WG', 'GHO','LAP']"
    [companyIds]="[101, 25, 6]"
    [companyId]="companyId"
    [text]="companyId == 6 ? ('DISCLAIMER_SPECS_LAP' | translate) :('DISCLAIMER_SPECS' | translate)"
    [class]="'d-block mx-3 px-1'"
  ></app-disclaimer>
</div>